import { env } from "../env/env";

const RouterService = {
  getLocationFromPath(path: string): number | undefined {
    const bits = path.replace(env.dashboardPath, "").split("/");
    const id = bits[2];
    if (id) {
      const locationId = parseInt(id);
      if (!isNaN(locationId)) {
        return locationId;
      }
    }
  },
};

export default RouterService;
